<template>
    <multiselect
        v-model="selected_value"
        :options="options"
        :searchable="true"
        :placeholder="'Search for your Hero'"
        selectLabel="select"
        deselectLabel=""
        selectedLabel=""
        :disabled="disabled"
        :multiple="multiple"
        :loading="loading"
        :custom-label="nameWithEmail"
        :label="label"
        track-by="email"
        @search-change="getData"
        style="min-width: 200px"
    >
        <template slot="noResult"> Not found</template>
        <template slot="noOptions"> Search for your Hero</template>
        <template slot="caret">
            <inline-svg class="multiselect-icon" src="/assets/img/icons/search-icon.svg"></inline-svg>
        </template>
        <template slot="singleLabel", slot-scope="props">
            <inline-svg class="multiselect-icon" src="/assets/img/icons/search-icon.svg"></inline-svg>
        </template>
        <template slot="tag" slot-scope="props">
            <span class="multiselect__tag">
                <span class="d-flex align-items-center" style="gap: 4px">
                    <inline-svg src="/assets/img/avatar-default.svg"></inline-svg>
                    {{ props.option.name }} - ({{ props.option.email}})
                </span>
                <i aria-hidden="true" tabindex="1" class="multiselect__tag-icon"></i>
            </span>
        </template>
    </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect';
import debounce from 'lodash/debounce';

export default {
    name: 'HeroSelect',
    props: ['value', 'disabled', 'multiple', 'type', 'placeholder', 'label'],
    components: {Multiselect},
    data() {
        return {
            selected_value: null,
            loading: false,
            options: [],
        };
    },
    methods: {
        getData: debounce(function (query) {
            if (!query) {
                return;
            }
            this.loading = true;
            this.$http.post('/hero/search', { query })
                .then(function (res) {
                    this.loading = false;
                    this.options = res.body.data;
                }).catch(() => {
                this.loading = false;
            });
        }, 500),
        nameWithEmail ({ name, email }) {
            return `${name} - (${email})`
        },
    },
    watch: {
        value(a) {
            this.selected_value = a;
        },
        selected_value(option) {
            if (!option) {
                this.$emit('input', null);
                this.$emit('change', null);
                this.$emit('setId', null);
            } else {
                this.$emit('input', option);
                this.$emit('change', option);
                this.$emit('setId', option ? option.id : null);
            }
        },
    },
    mounted() {
        if (this.value) {
            this.selected_value = this.value;
        }
    },
};
</script>
